/**
 * Module dependencies.
 */

import { Radio } from 'src/components/core';
import { ReactElement, ReactNode, useCallback } from 'react';
import { units } from '@untile/react-components';
import { useSort } from 'src/context/sort/context';
import styled from 'styled-components';

/**
 * `Props` type.
 */

type Props = {
  className?: string;
  label: ReactNode;
  name: string;
  value: string;
};

/**
 * `StyledRadio` styled component.
 */

const StyledRadio = styled(Radio)`
  padding: ${units(1)} 0;
`;

/**
 * `SortItem` component.
 */

const SortItem = (props: Props): ReactElement => {
  const { className, label, name, value } = props;
  const { isSortSelected, onSet } = useSort();
  const handleChange = useCallback(
    event => {
      onSet(event.target.value);
    },
    [onSet]
  );

  return (
    <StyledRadio
      checked={isSortSelected(value)}
      className={className}
      label={label}
      name={name}
      onChange={handleChange}
      value={value}
    />
  );
};

/**
 * Export `SortItem` component.
 */

export default SortItem;
